import BaseForm from './BaseForm';

export default BaseForm;